import { render, staticRenderFns } from "./SalesOrderViewDetailsSalesOrderItemTable.vue?vue&type=template&id=8d649822"
import script from "./SalesOrderViewDetailsSalesOrderItemTable.vue?vue&type=script&lang=js"
export * from "./SalesOrderViewDetailsSalesOrderItemTable.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderViewDetailsSalesOrderItemTable.vue?vue&type=style&index=0&id=8d649822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports